export default "__VITE_ASSET__n$zNXirC__"